import React, { forwardRef } from "react";
import { ButtonDS, Label } from "./styles";
import * as MdIcons from "react-icons/md";
// eslint-disable-next-line

/** @typedef {import("./button.d.ts").IButton} IButton */
/**
 * Componente de botão
 * @param {IButton} props - Props do componente
 * @returns {JSX.Element} Componente do botão
 **/
const Button = forwardRef(
	/**
	 * Componente de botão
	 * @param {IButton}
	 * @returns {JSX.Element} Componente do botão
	 **/
	({ btnType = "default", type = "button", disabled, loading, title, css, icons, children, ...rest }, ref) => {
		/**
		 * @type {import("react-icons/lib").IconBaseProps}
		 */
		const IconComponent = MdIcons[icons];

		const config = {
			default: "btn-primary",
			outline: "btn-outline-primary",
			fill: "btn-fill-primary",
			icon: "btn-icon",
		};

		const configIconColor = {
			default: "#13141b",
			outline: "#01e59b",
			fill: "#01e59b",
			icon: "#ffffff",
		};

		return (
			<ButtonDS
				ref={ref}
				{...rest}
				disabled={disabled || loading}
				className={`btn ${loading ? "dot" : config[btnType]} ${css ? css : ""} ${disabled || loading ? "disabled" : ""}`}
				type={type}
			>
				{icons && (
					<IconComponent
						size={24}
						color={configIconColor[btnType]}
						style={{ marginRight: "0.25rem" }}
					/>
				)}
				{!loading && title && <Label>{title}</Label>}
				{children}
			</ButtonDS>
		);
	}
);

Button.displayName = "Button";
export default Button;
